import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropContent from "../WaveDropContent";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "../dropContentPresentation";
interface ParticipationDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onLongPress: () => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export default function ParticipationDropContent(t0) {
  const $ = _c(11);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onLongPress,
    onDropContentClick,
    onQuoteClick,
    setLongPressTriggered,
    isCompetitionDrop: t1,
    contentPresentation: t2
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const contentPresentation = t2 === undefined ? "default" : t2;
  const hasTouch = useIsTouchDevice();
  let t3;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== hasTouch || $[4] !== isCompetitionDrop || $[5] !== onDropContentClick || $[6] !== onLongPress || $[7] !== onQuoteClick || $[8] !== setActivePartIndex || $[9] !== setLongPressTriggered) {
    t3 = <div><WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={onLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={isCompetitionDrop} hasTouch={hasTouch} contentPresentation={contentPresentation} /></div>;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = hasTouch;
    $[4] = isCompetitionDrop;
    $[5] = onDropContentClick;
    $[6] = onLongPress;
    $[7] = onQuoteClick;
    $[8] = setActivePartIndex;
    $[9] = setLongPressTriggered;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}